<template>
  <div id="dashboard-patients-table">
    <!--<v-client-table
      id="patientsTable"
      ref="patientsTable"
      name="patientsTable"
      :data="patientsData"
      :columns="columns"
      :options="tableOptions"
      @row-click="directToPatient"
    >
      <span slot="created_at" slot-scope="{row}">
        {{row.created_at | localTime('YYYY-MM-DD HH:mm')}}
      </span>
    </v-client-table>-->

    <div class="table-container">
      <div class="text-center loading-overlay" v-if="isLoading">
        <LoadingAnimation/>
      </div>

      <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
        <div class="row">
          <div class="col-12 col-md-4">
            <range-date-picker
              id="statistics-date-range"
              :label="$t('statistics2.hear.sublabels.period')"
              v-model="filters.dates"
              :placeholder="this.$t('agenda.reports.date_range')"
              :config="{ maxInterval: { value: 6, unit: 'months' } }"
              :clearable="true"
            >
            </range-date-picker>
          </div>

          <div class="col-12 col-md-4">
            <label class="form-label">
              {{ $t('menu.facilities') }}
            </label>
            <multiselect
              id="entities-filter"
              v-model="filters.facilities"
              :options="readableFacilities"
              track-by="id"
              :customLabel="formatedEntityLabel"
              :placeholder="readableFacilities.length ? $t('dashboard_new_evollu.values.several_facilities') : $t('dashboard_new_evollu.values.empty_facilities')"
              :allow-empty="true"
              :multiple="false"
              :internal-search="true"
              :disabled="!readableFacilities.length"
            >

              <template slot="clear">
                <!--<span class="multiselect__clear" v-if="filters.entities.length"
                      @mousedown.prevent.stop="filters.entities = []"></span>-->
                <span class="multiselect__clear" v-if="filters.facilities !== null"
                      @mousedown.prevent.stop="filters.facilities = null"></span>
              </template>
            </multiselect>
          </div>

          <div class="col-12 col-md-4">
            <label class="form-label">
              {{ $t('dashboard_new_evollu.values.patient_status') }}
            </label>
            <multiselect
              id="entities-filter"
              v-model="filters.patientStatus"
              :options="patientStatuses"
              track-by="id"
              :customLabel="(val) => $t(`dashboard_new_evollu.values.patient_statuses.${val.slug}`)"
              :allow-empty="false"
              :multiple="false"
              :internal-search="false"
            >

            </multiselect>
          </div>
        </div>
      </div>
      <v-server-table
        :columns="columns"
        :options="tableOptions"
        id="checkupPlusPatientsTable"
        ref="checkupPlusPatientsTable"
        name="checkupPlusPatientsTable"
        @row-click="directToPatient"
      >

        <!--<div slot="afterLimit">
          <Searchable class="mr-2" :querySearch.sync="querySearch"/>
        </div>-->
        <span slot="created" slot-scope="{row}">
        {{ row.created ? moment(row.created).format("YYYY/MM/DD") : "N/A" }}
      </span>
        <span slot="updated" slot-scope="{row}">
        {{ row.updated ? moment(row.updated).format("YYYY/MM/DD") : "N/A" }}
      </span>
        <span slot="mobile" slot-scope="{row}">
        {{ row.mobile || "N/A" }}
      </span>
        <span slot="email" slot-scope="{row}">
        {{ row.email || "N/A" }}
      </span>
        <span slot="dateOfBirth" slot-scope="{row}">
        {{ row.dateOfBirth ? moment(row.dateOfBirth).format("YYYY/MM/DD") : "N/A" }}
      </span>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {ClientTable} from 'vue-tables-2'
import ApiService from "@/api/ApiService";
import axios from "axios";
import TableQueryMixin from "@/mixins/TableQueryMixin";
import {mapState} from "vuex";
import Searchable from "@/components/common/Searchable";
import {OneCareService} from "@/api/OneCareService";
import MultiselectLabelFormatter from "@/mixins/MultiselectLabelFormatter";
import ClustersAndEntitiesMixin from "@/mixins/ClustersAndEntitiesMixin";
import Multiselect from "vue-multiselect";
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import {CHECkUP_PLUS_PATIENTS_TABLE} from "@/local-storage/LocalStorageKeys";
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation";
import RangeDatePicker from "@/components/common/RangeDatePicker";

Vue.use(ClientTable, {}, false, 'bootstrap4')

const DASHBOARD_INFO_TYPE = 110;

export default {
  name: "PatientsTable",
  props: {
    querySearch: {
      type: String,
      required: false
    },
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {RangeDatePicker, LoadingAnimation, Searchable, Multiselect},
  mixins: [
    TableQueryMixin,
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin,
  ],
  async mounted() {
    //await this.loadLocalStorage()
    this.getTableReference().setFilter('')
    this.getTableReference().setLimit(10)
    this.getTableReference().orderBy = {
      'ascending': false,
      'column': false
    }
  },
  data() {
    return {
      hasMadeFirstLoad: false,
      isLoading: false,
      patientStatuses: [
        {
          id: 1,
          slug: 'active'
        },
        {
          id: 2,
          slug: 'inactive'
        }
      ],
      queryUrl: `${OneCareService.baseURL}/patients?roleCategoryId=0&details=false`,
      tableOptions: {
        requestFunction: (data) => {
          const page = data.page
          return new Promise((resolve, reject) => {
            if (this.cancelationCallback !== null) {
              this.cancelationCallback()
            }
            this.isLoading = true
            const limit = this.$refs.checkupPlusPatientsTable ? this.$refs.checkupPlusPatientsTable.limit : 10
            const queryUrl = this.queryUrl + `&pageSize=${limit}`
            data.by_created = false
            data.by_updated = false
            if (!this.hasMadeFirstLoad) {
              data.facilityId_evollu = null
              data.status = 1
              data.from = null
              data.to = null
              data.orderBy = null
              data.ascending = 0
            }
            if (data.status === undefined || data.status === '') {
              data.status = 1
            }
            if (Object.keys(data).includes('facilityId_evollu') && data.facilityId_evollu === '') {
              data.facilityId_evollu = null
            }
            if (Object.keys(data).includes('from') && data.from === '') {
              data.from = null
              data.to = null
            }
            data.order_date_desc = data.ascending !== 1
            if (data.orderBy === 'updated') {
              data.by_updated = true
              data.by_created = false
            } else if (data.orderBy === 'created') {
              data.by_created = true
              data.by_updated = false
            } else if (data.orderBy === null) {
              data.by_created = false
              data.by_updated = false
            }
            /*if (data.orderBy !== undefined && data.orderBy !== false) {
              if (data.from === null || data.to === null) {
                this.filters.dates.start = this.moment().startOf('month').format('YYYY-MM-DD')
                this.filters.dates.end = this.moment().endOf('month').format('YYYY-MM-DD')
                return
              }
              if (data.orderBy === 'updated') {
                data.by_updated = true
              } else if (data.orderBy === 'created') {
                data.by_created = true
              }
            }*/
            ApiService.cancelableQuery(queryUrl, data, new axios.CancelToken(c => {
              this.cancelationCallback = c
            }))
              .then(response => {
                if (response.data.page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = response.data.page
                  }
                } else if (page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = page
                  }
                }
                this.hasMadeFirstLoad = true
                resolve({
                  data: response.data.objects ? response.data.objects : [],
                  count: response.data.totalItems ? response.data.totalItems : 0,
                  page: response.data.page ? response.data.page : 1
                })
              })
              .catch(error => {
                if (!axios.isCancel(error)) {
                  reject(error)
                }
              })
              .finally(() => {
                this.isLoading = false
              })
          })
        },
        sortable: ['created', 'updated'],
        filterable: true,
        customFilters: ['facilityId_evollu', 'from', 'to', 'status'],
        skin: 'table table-striped table-hover is-fullwidth',
        headings: {
          created: this.$t('ranu.records.created_at'),
          updated: this.$t('ranu.records.updated_at'),
          name: this.$t('accounts.name'),
          mobile: this.$t('people.inputs.mobile-phone'),
          email: this.$t('accounts.email'),
          dateOfBirth: this.$t('clinical.people.birthday')
        },
      },
      columns: ['created', 'updated', 'name', 'mobile', 'email', 'dateOfBirth'],
      entityOptions: [],
      filters: {
        facilities: null,
        patientStatus: {
          id: 1,
          slug: 'active'
        },
        dates: {
          start: null,
          end: null,
        },
      },
    }
  },
  methods: {
    directToPatient: function ({row}) {
      this.$emit('row-clicked', {patient: row})
    },
    getTableReference: function () {
      return this.$refs.checkupPlusPatientsTable
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(CHECkUP_PLUS_PATIENTS_TABLE)
        if (state !== null) {
          this.filters = {
            ...this.filters,
            ...state,
            patientStatus: this.patientStatuses.filter(s => s.id === state.patientStatus)[0]
          }
        }
        resolve()
      })
    },
  },
  computed: {
    ...mapState({
      oneCareToken(state, getters) {
        return getters['oneCareToken'] || []
      },
      checkupPlusService: function () {
        return this.$store.state.services.find(service => service.url === this.$store.state.onecare_server) || null
      },
      readableEntities: function () {
        if (!this.checkupPlusService) {
          return []
        }
        let permissions = this.checkupPlusService.user_permissions.filter(
          p => p.info_type === DASHBOARD_INFO_TYPE && p.access_type >= this.$store.state.accessTypes.READ
        )

        if (permissions.some(p => p.entity_id === null)) {
          return [...this.checkupPlusService.entities]
        } else {
          return this.checkupPlusService.entities.filter(entity => permissions.some(p => p.entity_id === entity.id))
        }
      },
      readableFacilities: function () {
        if (!this.readableEntities.length) {
          return []
        }
        return this.readableEntities.map(entity => entity.facilities).flat()
      },
    }),
  },
  watch: {
    querySearch: {
      handler: function (value) {
        this.querySearch = value || ''
        if (value.length == 0 || value.length > 2) {
          this.loading = true
          this.getTableReference().setFilter(value)
          this.loading = false
        }
      },
    },
    'filters.facilities': {
      handler: function (options) {
        if (options !== null) {
          this.emitTableFilter('vue-tables.checkupPlusPatientsTable.filter::facilityId_evollu', options.id)
        } else {
          if (this.getTableReference() !== undefined) {
            this.emitTableFilter('vue-tables.checkupPlusPatientsTable.filter::facilityId_evollu', null)
            //this.getTableReference().customQueries.from = this.moment(this.filters.dates.start).format('YYYY/MM/DD') || ''
            //this.emitTableFilter('vue-tables.checkupPlusPatientsTable.filter::to', this.moment(this.filters.dates.end).format('YYYY/MM/DD') || '')
          }

        }
      },
      immediate: true,
      deep: true,
    },
    'filters.dates': {
      handler: function (value) {
        if (this.getTableReference() !== undefined) {
          if (value.start === null || value.end === null) {
            this.getTableReference().orderBy = {
              'ascending': false,
              'column': false
            }

            this.getTableReference().customQueries.from = null
            this.emitTableFilter('vue-tables.checkupPlusPatientsTable.filter::to', null)
          } else {
            if (this.getTableReference().orderBy.column === false) {
              this.getTableReference().orderBy = {
                'ascending': false,
                'column': 'updated'
              }
            }
            this.getTableReference().customQueries.from = this.moment(value.start).format('YYYY/MM/DD') || ''
            this.emitTableFilter('vue-tables.checkupPlusPatientsTable.filter::to', this.moment(value.end).format('YYYY/MM/DD') || '')
          }
        }
      },
      immediate: true,
      deep: true,
    },
    'filters.patientStatus': {
      handler: function (value) {
        this.emitTableFilter('vue-tables.checkupPlusPatientsTable.filter::status', value.id)
      },
      immediate: false,
      deep: true,
    }
  }
}

</script>

<style lang="scss">
.unselectedDateLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  text-decoration: line-through !important;
}

.dateSeparatorLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

.selectedDateLabel {
  font-size: 0.6rem !important;
  color: #29c4a9 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

.table-container {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}
</style>
